import { call, put, takeEvery } from 'redux-saga/effects'

import * as Api from '../api/flyout-api';

function* fetchFlyoutConfig(action) {
    try {
        const config = yield call(Api.fetchFlyoutConfig);
        yield put({
            type: 'FLYOUT_CONFIG_FETCH_SUCCEEDED',
            payload: { config }
        });
    } catch (e) {
        yield put({
            type: 'FLYOUT_CONFIG_FETCH_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* openFlyout(action) {
    try {
        yield call(Api.openFlyout, action.payload.flyoutId, action.payload.flyoutProps);
        yield put({
            type: 'FLYOUT_OPEN_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'FLYOUT_OPEN_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* closeFlyout(action) {
    try {
        yield call(Api.closeFlyout);
        yield put({
            type: 'FLYOUT_CLOSE_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'FLYOUT_CLOSE_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* watchGetFlyoutConfig() {
    yield takeEvery('FLYOUT_CONFIG_FETCH_REQUESTED', fetchFlyoutConfig);
}

function* watchFlyoutOpen() {
    yield takeEvery('FLYOUT_OPEN_REQUESTED', openFlyout);
}

function* watchFlyoutClose() {
    yield takeEvery('FLYOUT_CLOSE_REQUESTED', closeFlyout);
}

export default [watchGetFlyoutConfig, watchFlyoutClose, watchFlyoutOpen];
